import { Box } from '@mui/material'

import { Link } from 'components/Link'
import { FullLogotype } from 'features/layout/components/Logo'
import { ROUTES } from 'routes'

export const Logo = (): JSX.Element => {
  return (
    <Box
      sx={{
        p: 4,
        position: 'absolute',
        top: 0,
      }}
    >
      <Link to={ROUTES.BASE.ROOT}>
        <FullLogotype />
      </Link>
    </Box>
  )
}
